class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      if (this.dataset.bundle) {
        var toHideArr = document.querySelectorAll(`.cart-item[data-bundle='${this.dataset.bundle}']`);
        toHideArr.forEach((el) => {
          el.style.setProperty('display','none','important');
        });
      } else {
        this.closest('.cart-item').style.setProperty('display','none','important');
      }
      cartItems.updateQuantity(this.dataset.index, 0,null,null,this.dataset.bundle);
      setTimeout(()=>{window.freeplaypackthreshold?.checkCart()},1000);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;
  cartJsonData = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    
    document.addEventListener("la:dn:cart:updated", async function(event) {
        const discountedCart = event.detail.data[0];
        console.log('The cart is updated by Discount Ninja', discountedCart);
        
        // Add delay before updating cart drawer header
        setTimeout(() => {
            try {          
                var price = discountedCart.total.discountedPrice || 0;
                var currency = discountedCart.currency || 'USD';
                console.log('Updating cart drawer header with price and currency:', price, currency);
                document.querySelector('cart-drawer-items').updateCartDrawerHeader(price,currency);
            } catch (error) {
                console.log('Error updating cart drawer header:', error);
            }
        }, 500); // 500ms delay
    });
    fetch('/cart.js').then((r) => r.json()).then((cart) => {
      this.cartJsonData = cart;
      // make cartjson data global
      window.cartJsonData = this.cartJsonData;
    });  
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  
  // Use Shopify's money formatting
  formatMoney(cents, currency = 'AUD') {
      // Use Shopify's money formatter if available
      if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents);
      }
      
      // Fallback to Intl.NumberFormat with proper locale detection
      const locale = this.getCurrencyLocale(currency);
      return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2
      }).format(cents / 100);
  }
  
  // Get proper locale for currency formatting
  getCurrencyLocale(currency) {
      // Use Shopify's locale if available
      if (window.Shopify && window.Shopify.locale) {
          return window.Shopify.locale;
      }
      
      // Fallback locale mapping with AUD as base
      const localeMap = {
          'AUD': 'en-AU', // Base currency
          'USD': 'en-US',
          'GBP': 'en-GB', 
          'EUR': 'en-GB', // or 'de-DE' depending on your preference
          'CAD': 'en-CA',
          'JPY': 'ja-JP',
          'NZD': 'en-NZ'
      };
      return localeMap[currency] || 'en-AU'; // Default to Australian locale
  }

  // Convert AUD base amounts to target currency using Shopify's currency rates
  convertFromAUD(audAmount, targetCurrency) {
      // If target currency is AUD or conversion system not available, return original amount
      if (targetCurrency === 'AUD') {
          return audAmount;
      }
      
      // Use Shopify's currency rates if available
      try {
          // Check if Shopify currency rate is available
          if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
              const rate = parseFloat(window.Shopify.currency.rate);
              const activeCurrency = window.Shopify.currency.active;
              
              // Verify the active currency matches our target currency
              if (activeCurrency === targetCurrency && rate > 0) {
                  // The rate is from AUD (base currency) to the active currency
                  const convertedAmount = Math.round(audAmount * rate);
                  console.log(`Currency conversion: ${audAmount} AUD cents -> ${convertedAmount} ${targetCurrency} cents (rate: ${rate})`);
                  return convertedAmount;
              } else {
                  console.warn(`Currency mismatch: target=${targetCurrency}, active=${activeCurrency}`);
              }
          }
          
          // Fallback: try using Shopify.formatMoney for conversion hints
          if (window.Shopify && window.Shopify.formatMoney) {
              console.warn('No currency rates available, using original AUD amount');
              return audAmount;
          }
          
      } catch (error) {
          console.warn('Shopify currency conversion failed:', error);
      }
      
      // Final fallback to original amount if conversion fails
      console.warn('Currency conversion not available, using AUD amounts');
      return audAmount;
  }

  // Get currency-aware store credit amount and text
  getStoreCreditText(currency) {
      // For USD, always return standardized $20 USD text
      if (currency === 'USD') {
          return '$20 USD';
      }
      
      // For other currencies, convert from AUD base amount
      const audStoreCreditCents = 2500; // $25 AUD
      const convertedAmount = this.convertFromAUD(audStoreCreditCents, currency);
      const formattedAmount = this.formatMoney(convertedAmount, currency);
      return formattedAmount.replace('.00', ''); // Remove .00 for cleaner display
  }
  
  updateCartDrawerHeader(cartPrice = 0,currency = 'AUD') {
      if (typeof window.promoBannerv2 == 'object') {
        window.promoBannerv2.update(cartPrice);
        return;
      }
      const cartDrawer = document.querySelector('cart-drawer');
      console.log('Start Header Drawer Update',!!cartDrawer);
      if (!cartDrawer) return;

      // Get cart currency - prefer passed parameter, fallback to cart data or AUD
      const cartCurrency = currency || cartDrawer.dataset.currency || 'AUD';
      const countryCode = cartDrawer.dataset.countryCode;
      const currencySymbol = cartDrawer.dataset.currencySymbol;
      // Get text variables from data attributes
      var  freeShippingUnlocked = cartDrawer.dataset.freeShippingUnlocked;
      const freeShippingAway = cartDrawer.dataset.freeShippingAway;
      var freeShippingAwaySuffix = cartDrawer.dataset.freeShippingAwaySuffix;
      const freeShippingUs = cartDrawer.dataset.freeShippingUs;
      
      // Get threshold values from dataset attributes
      const freeShippingPrice = parseInt(cartDrawer.dataset.freeShippingPrice) || 0;
      const freeShippingPriceUk = parseInt(cartDrawer.dataset.freeShippingPriceUk) || 0;
      const freeShippingPriceUs = parseInt(cartDrawer.dataset.freeShippingPriceUs) || 0;
      
      const secondTierThreshold = parseInt(cartDrawer.dataset.freeShippingTwoPrice) || 0;
      const secondTierThresholdUk = parseInt(cartDrawer.dataset.freeShippingTwoPriceUk) || 0;
      const secondTierThresholdUs = parseInt(cartDrawer.dataset.freeShippingTwoPriceUs) || 0;
      
      let threshold, secondTier, width;
      const progressBar = document.querySelector('.free-sf-bar');
      const promoBanner = document.querySelector('#cart-promo-banner');
      
      if (!progressBar || !promoBanner) {
          console.log('❌ Missing required elements - progressBar:', !!progressBar, 'promoBanner:', !!promoBanner);
          return;
      }
      
      // Apply correct thresholds based on currency (override dataset values)
      if (cartCurrency === 'USD') {
          // USD: $0 (tier 1) / $79 (tier 2)
          threshold = 0;
          secondTier = 7900;
      } else if (cartCurrency === 'AUD') {
          // AUD (Australia): $89 (tier 1) / $99 (tier 2)
          threshold = 8900;
          secondTier = 9900;
      } else {
          // promoBanner.style.display = 'none';
          // return;
          // All other currencies: Convert AUD base amounts to local currency
          const audTier1 = 8900; // $89 AUD
          const audTier2 = 9900; // $99 AUD
          threshold = this.convertFromAUD(audTier1, cartCurrency);
          secondTier = this.convertFromAUD(audTier2, cartCurrency);
      }
      
      console.log('Currency conversion debug - Cart Currency:', cartCurrency, 'Country:', countryCode, 'Tier 1:', threshold, 'Tier 2:', secondTier);
      
      // Calculate progress width based on tier system
      if (threshold === 0 && secondTier > 0) {
          // Special case: tier 1 always unlocked (threshold = 0), only show progress toward tier 2
          if (cartPrice >= secondTier) {
              width = 100; // Tier 2 achieved
          } else {
              width = (cartPrice / secondTier) * 100; // Start at 0%, progress to 100%
          }
      } else if (secondTier > 0 && secondTier > threshold) {
          // Two-tier system: tier 1 (0-50%), tier 2 (50-100%)
          if (cartPrice >= secondTier) {
              // Tier 2 achieved - show 100%
              width = 100;
          } else if (threshold > 0 && cartPrice >= threshold) {
              // Tier 1 achieved, progress toward tier 2 (50-100%)
              const tier2Progress = ((cartPrice - threshold) / (secondTier - threshold)) * 50;
              width = 50 + tier2Progress;
          } else if (threshold === 0) {
              // Free shipping is free (tier 1 = 0), progress toward tier 2 only (0-100%)
              width = (cartPrice / secondTier) * 100;
          } else {
              // Below tier 1, progress toward tier 1 (0-50%)
              width = (cartPrice / threshold) * 50;
          }
      } else {
          // Single-tier system: calculate progress toward tier 1 only (0-100%)
          width = Math.min((cartPrice / threshold) * 100, 100);
      }
      
      // Remove existing tier classes
      promoBanner.classList.remove('tier-2');
      
      // ALWAYS clear all existing paragraph content first to prevent conflicts
      const allPs = promoBanner.querySelectorAll('p');
      allPs.forEach(p => p.remove());
      
      // Update header text and styling based on tier
      if (secondTier > 0 && cartPrice >= secondTier) {
          // Tier 2 - Free Shipping + Store Credit (ONLY when second tier is actually reached)
          console.log('Tier 2 achieved - showing store credit message');
          
          // Create new content
          const p1 = document.createElement('p');
          p1.textContent = 'Congrats! you have unlocked free shipping';
          const p2 = document.createElement('p');
          p2.style.fontWeight = 'normal';
          p2.textContent = `and ${this.getStoreCreditText(cartCurrency)} Store Credit!`;
          
          promoBanner.insertBefore(p1, promoBanner.querySelector('.free-sf-bar-container'));
          promoBanner.insertBefore(p2, promoBanner.querySelector('.free-sf-bar-container'));
          
          promoBanner.classList.add('tier-2');
          width = 100;
      } else if (threshold === 0 && secondTier > 0) {
          // Special case: tier 1 always unlocked (threshold = 0), show tier 2 progress
          console.log('Tier 1 always unlocked - showing tier 2 progress');
          const remainingForTier2 = secondTier - cartPrice;
          const formattedTier2Amount = this.formatMoney(remainingForTier2, cartCurrency);
          
          // Create new content - NO store credit message here
          const p1 = document.createElement('p');
          p1.textContent = 'Congrats! you have unlocked free shipping';
          const p2 = document.createElement('p');
          p2.style.fontSize = '10px';
          p2.textContent = `You Are ${formattedTier2Amount} Away From ${this.getStoreCreditText(cartCurrency)} Store Credit!`;
          
          promoBanner.insertBefore(p1, promoBanner.querySelector('.free-sf-bar-container'));
          promoBanner.insertBefore(p2, promoBanner.querySelector('.free-sf-bar-container'));
          
      } else if (cartPrice >= threshold) {
          // Tier 1 - Free Shipping Unlocked (NO store credit message here)
          console.log('Tier 1 achieved - showing tier 2 progress');
          
          const p1 = document.createElement('p');
          if (secondTier > 0 && secondTier > threshold) {
              // Show tier 2 progress if second tier exists
              const remainingForTier2 = secondTier - cartPrice;
              const formattedTier2Amount = this.formatMoney(remainingForTier2, cartCurrency);
              
              p1.innerHTML = `${freeShippingUnlocked}<br><span>Spend ${formattedTier2Amount} More For ${this.getStoreCreditText(cartCurrency)} Store Credit!</span>`;
          } else {
              // Single tier system - just show free shipping unlocked
              p1.textContent = freeShippingUnlocked;
          }
          
          promoBanner.insertBefore(p1, promoBanner.querySelector('.free-sf-bar-container'));
          
      } else {
          // Below Tier 1 - Show amount needed for free shipping (NO store credit message here)
          console.log('Below tier 1 - showing shipping progress');
          const remaining = threshold - cartPrice;
          const formattedAmount = this.formatMoney(remaining, cartCurrency);
          
          const p1 = document.createElement('p');
          p1.textContent = `${freeShippingAway} ${formattedAmount} ${freeShippingAwaySuffix}`;
          promoBanner.insertBefore(p1, promoBanner.querySelector('.free-sf-bar-container'));
      }
      
      // Update progress bar
      progressBar.style.width = `${width}%`;
      
      // Add tier checkpoints to progress bar container
      const progressContainer = document.querySelector('.free-sf-bar-container');
      console.log('Progress container found for checkpoints:', !!progressContainer);
      console.log('Threshold:', threshold, 'Second tier:', secondTier, 'Cart price:', cartPrice);
      console.log('Condition checks:');
      console.log('- threshold === 0 && secondTier > 0:', threshold === 0 && secondTier > 0);
      console.log('- secondTier > 0 && secondTier > threshold:', secondTier > 0 && secondTier > threshold);
      console.log('- threshold > 0:', threshold > 0);
      
      if (progressContainer) {
          // Remove existing checkpoints and labels
          progressContainer.querySelectorAll('.tier-checkpoint, .checkpoint-label').forEach(el => el.remove());
          
          if (threshold === 0 && secondTier > 0) {
              // Special case: tier 1 always unlocked, show both checkpoints
              console.log('Creating both checkpoints (threshold = 0)');
              
              // Tier 1 checkpoint at start (0% position)
              const tier1Checkpoint = document.createElement('div');
              tier1Checkpoint.className = `tier-checkpoint tier-1-start achieved`; // Always achieved when threshold = 0
              progressContainer.appendChild(tier1Checkpoint);
              console.log('Tier 1 checkpoint created at start, class:', tier1Checkpoint.className);
              console.log('Tier 1 checkpoint element:', tier1Checkpoint);
              
              // Tier 1 label
              const tier1Label = document.createElement('div');
              tier1Label.className = `checkpoint-label tier-1-start achieved`;
              tier1Label.textContent = 'Free Shipping';
              tier1Label.style.position = 'absolute';
              tier1Label.style.left = '-8px';
              tier1Label.style.top = '-28px';
              tier1Label.style.transform = 'translateX(0)';
              tier1Label.style.fontSize = '8px';
              tier1Label.style.fontWeight = '600';
              tier1Label.style.color = '#0A00B4';
              tier1Label.style.textTransform = 'uppercase';
              tier1Label.style.letterSpacing = '0.5px';
              tier1Label.style.whiteSpace = 'nowrap';
              tier1Label.style.zIndex = '1001';
              tier1Label.style.textAlign = 'center';
              tier1Label.style.lineHeight = '1';
              progressContainer.appendChild(tier1Label);
              console.log('Tier 1 label created, class:', tier1Label.className);
              
              // Tier 2 checkpoint at end (100% position)
              const tier2Checkpoint = document.createElement('div');
              tier2Checkpoint.className = `tier-checkpoint tier-2-end ${cartPrice >= secondTier ? 'achieved' : ''}`;
              progressContainer.appendChild(tier2Checkpoint);
              console.log('Tier 2 checkpoint created, class:', tier2Checkpoint.className);
              
              // Tier 2 label
              const tier2Label = document.createElement('div');
              tier2Label.className = `checkpoint-label tier-2-end ${cartPrice >= secondTier ? 'achieved' : ''}`;
              const storeCreditAmount = this.getStoreCreditText(cartCurrency);
              tier2Label.textContent = `${storeCreditAmount} Store Credit`;
              tier2Label.style.position = 'absolute';
              tier2Label.style.left = 'calc(100% - 8px)';
              tier2Label.style.top = '-28px';
              tier2Label.style.transform = 'translateX(-50%)';
              tier2Label.style.fontSize = '8px';
              tier2Label.style.fontWeight = '600';
              tier2Label.style.color = cartPrice >= secondTier ? '#00B308' : '#666';
              tier2Label.style.textTransform = 'uppercase';
              tier2Label.style.letterSpacing = '0.5px';
              tier2Label.style.whiteSpace = 'nowrap';
              tier2Label.style.zIndex = '1001';
              tier2Label.style.textAlign = 'center';
              tier2Label.style.lineHeight = '1';
              progressContainer.appendChild(tier2Label);
              console.log('Tier 2 label created, class:', tier2Label.className);
              
          } else if (secondTier > 0 && secondTier > threshold) {
              // Two-tier system: show both checkpoints (when threshold > 0)
              console.log('Creating both tier checkpoints');
              
              // Determine tier 1 position based on threshold value
              const tier1Position = threshold === 0 ? '0%' : '50%';
              const tier1LeftOffset = threshold === 0 ? '-8px' : '50%';
              const tier1Transform = threshold === 0 ? 'translateX(0)' : 'translateX(-50%)';
              
              // Tier 1 checkpoint
              const tier1Checkpoint = document.createElement('div');
              tier1Checkpoint.className = `tier-checkpoint tier-1 ${threshold === 0 || cartPrice >= threshold ? 'achieved' : ''}`;
              tier1Checkpoint.style.position = 'absolute';
              tier1Checkpoint.style.left = tier1LeftOffset;
              tier1Checkpoint.style.top = '-4px';
              tier1Checkpoint.style.width = '16px';
              tier1Checkpoint.style.height = '16px';
              tier1Checkpoint.style.borderRadius = '50%';
              tier1Checkpoint.style.border = '3px solid #fff';
              tier1Checkpoint.style.background = (threshold === 0 || cartPrice >= threshold) ? '#fff' : '#0A00B4';
              tier1Checkpoint.style.borderColor = '#0A00B4';
              tier1Checkpoint.style.zIndex = '1000';
              tier1Checkpoint.style.transform = tier1Transform;
              tier1Checkpoint.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              tier1Checkpoint.style.display = 'block';
              progressContainer.appendChild(tier1Checkpoint);
              console.log('Tier 1 checkpoint created');
              
              // Tier 1 label
              const tier1Label = document.createElement('div');
              tier1Label.className = `checkpoint-label tier-1 ${threshold === 0 || cartPrice >= threshold ? 'achieved' : ''}`;
              tier1Label.textContent = 'Free Shipping';
              tier1Label.style.position = 'absolute';
              tier1Label.style.left = tier1LeftOffset;
              tier1Label.style.top = '-28px';
              tier1Label.style.transform = tier1Transform;
              tier1Label.style.fontSize = '8px';
              tier1Label.style.fontWeight = '600';
              tier1Label.style.color = (threshold === 0 || cartPrice >= threshold) ? '#0A00B4' : '#666';
              tier1Label.style.textTransform = 'uppercase';
              tier1Label.style.letterSpacing = '0.5px';
              tier1Label.style.whiteSpace = 'nowrap';
              tier1Label.style.zIndex = '1001';
              tier1Label.style.textAlign = 'center';
              tier1Label.style.lineHeight = '1';
              progressContainer.appendChild(tier1Label);
              console.log('Tier 1 label created');
              
              // Tier 2 checkpoint (at 100% position)
              const tier2Checkpoint = document.createElement('div');
              tier2Checkpoint.className = `tier-checkpoint tier-2 ${cartPrice >= secondTier ? 'achieved' : ''}`;
              tier2Checkpoint.style.position = 'absolute';
              tier2Checkpoint.style.right = '-8px';
              tier2Checkpoint.style.top = '-4px';
              tier2Checkpoint.style.width = '16px';
              tier2Checkpoint.style.height = '16px';
              tier2Checkpoint.style.borderRadius = '50%';
              tier2Checkpoint.style.border = '3px solid #fff';
              tier2Checkpoint.style.background = cartPrice >= secondTier ? '#fff' : '#00B308';
              tier2Checkpoint.style.borderColor = '#00B308';
              tier2Checkpoint.style.zIndex = '1000';
              tier2Checkpoint.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              tier2Checkpoint.style.display = 'block';
              progressContainer.appendChild(tier2Checkpoint);
              console.log('Tier 2 checkpoint created');
              
              // Tier 2 label
              const tier2Label = document.createElement('div');
              tier2Label.className = `checkpoint-label tier-2 ${cartPrice >= secondTier ? 'achieved' : ''}`;
              const storeCreditAmount = this.getStoreCreditText(cartCurrency);
              tier2Label.textContent = `${storeCreditAmount} Store Credit`;
              tier2Label.style.position = 'absolute';
              tier2Label.style.left = 'calc(100% - 8px)';
              tier2Label.style.top = '-28px';
              tier2Label.style.transform = 'translateX(-50%)';
              tier2Label.style.fontSize = '8px';
              tier2Label.style.fontWeight = '600';
              tier2Label.style.color = cartPrice >= secondTier ? '#00B308' : '#666';
              tier2Label.style.textTransform = 'uppercase';
              tier2Label.style.letterSpacing = '0.5px';
              tier2Label.style.whiteSpace = 'nowrap';
              tier2Label.style.zIndex = '1001';
              tier2Label.style.textAlign = 'center';
              tier2Label.style.lineHeight = '1';
              progressContainer.appendChild(tier2Label);
              console.log('Tier 2 label created');
              
          } else if (threshold > 0) {
              // Single-tier system: only show tier 1 checkpoint
              console.log('Creating single tier checkpoint');
              const tier1Checkpoint = document.createElement('div');
              tier1Checkpoint.className = `tier-checkpoint tier-1 ${cartPrice >= threshold ? 'achieved' : ''}`;
              tier1Checkpoint.style.cssText = `
                  position: absolute !important;
                  right: -8px !important;
                  top: -4px !important;
                  width: 16px !important;
                  height: 16px !important;
                  border-radius: 50% !important;
                  border: 2px solid #fff !important;
                  background: ${cartPrice >= threshold ? '#fff' : '#0A00B4'} !important;
                  border-color: #0A00B4 !important;
                  z-index: 10 !important;
                  box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
              `;
              progressContainer.appendChild(tier1Checkpoint);
              console.log('Single tier checkpoint created');
          } else {
              console.log('No checkpoints created - no valid tier configuration');
          }
          
          // Make progress container relative for positioning
          progressContainer.style.position = 'relative';
          progressContainer.style.overflow = 'visible';
          
          console.log('Checkpoints in container:', progressContainer.querySelectorAll('.tier-checkpoint').length);
      }
      
      var promoDiv = document.querySelector('#cart-promo-banner');
      if(promoDiv) promoDiv.style.display = '';
      console.log('Cart drawer header updated successfully',threshold,cartPrice,cartPrice >= threshold, 'Tier 2:', cartPrice >= secondTier, 'Progress width:', width + '%');
  }
  onChange(event) {
    if (event.target.dataset.exclude != 1) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    this.updateCartTotalWithoutDiscount();
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, bundle) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.cartJsonData = parsedState;
        if(bundle && parsedState.item_count){
          for (const key in parsedState.items) {
            if(typeof parsedState.items[key].properties._customBundle != 'undefined' && parsedState.items[key].properties._customBundle == bundle){
              var toHide = document.querySelector('#CartDrawer-Item-'+(parseInt(key)+1)+',#CartItem-'+(parseInt(key)+1));
              if(toHide) toHide.style.setProperty('display','none','important');
              setTimeout(() => {
                this.updateQuantity(parseInt(key) + 1, 0,null,null,bundle);
              }, 200);
              return;
            }
          }
        } else {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');
  
          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value');
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
  
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
  
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);
  
          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
  
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
          var cartPrice = parsedState.total_price || 0;
          var currency = parsedState.currency || 'USD';
        }
        this.updateCartDrawerHeader(cartPrice,currency);
      })
      .catch((e) => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.updateCartTotalWithoutDiscount(false);
        this.disableLoading(line);
        setTimeout(()=>window.freeplaypackthreshold?.checkCart(),500);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus?.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus?.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    var promoDiv = document.querySelector('#cart-promo-banner');
    if(promoDiv) promoDiv.style.display = 'none';
    console.log('enable loading');
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if(mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
  
      [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
  
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
  
      const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
      const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
  
      cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    }    
  }

  updateCartTotalWithoutDiscount(header = true) {
    console.log('updateCartTotalWithoutDiscount');    
    fetch(`/cart.js`)
      .then((response) => response.json())
      .then((cartVar) => {
        this.cartJsonData = cartVar;
        const cartItems = cartVar.items;
        var total = 0;
        for (const item of cartItems) {
          total += item.presentment_price * item.quantity;
        }
        // add total to cart attribute via post
        const body = JSON.stringify({ attributes: {total_without_discount:total} });
        fetch(`${routes.cart_update_url}.js`, { ...fetchConfig(), ...{ body } });
        if(header)this.updateCartDrawerHeader(cartVar.total_price,cartVar.currency);
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
